/**
 * Pré-carrega Montserrat (métrica fontkit + FontFace no document).
 * Usa as URLs do webpack — o @font-face em CSS relativo falhava em alguns
 * builds do CRA e a etiqueta caía na fonte do sistema.
 */
import MontserratBold from "./assets/Montserrat-Bold.ttf";
import MontserratLight from "./assets/Montserrat-Light.ttf";
import MontserratRegular from "./assets/Montserrat-Regular.ttf";
import { ensureFontsLoaded, getFonts } from "./limitString";

const FACES = [
  { family: "Montserrat-Bold", url: MontserratBold },
  { family: "Montserrat-Light", url: MontserratLight },
  { family: "Montserrat-Regular", url: MontserratRegular },
];

let cssInjected = false;
let facesPromise = null;

/** Injeta @font-face com URLs resolvidas pelo webpack (não paths relativos). */
const injectCssFaces = () => {
  if (cssInjected || typeof document === "undefined") return;
  const style = document.createElement("style");
  style.setAttribute("data-tag-fonts", "montserrat");
  style.textContent = FACES.map(
    ({ family, url }) => `
@font-face {
  font-family: "${family}";
  src: url("${url}") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}`
  ).join("\n");
  document.head.appendChild(style);
  cssInjected = true;
};

const loadDocumentFaces = async () => {
  if (typeof document === "undefined" || !document.fonts?.add) return;
  if (!facesPromise) {
    facesPromise = Promise.all(
      FACES.map(async ({ family, url }) => {
        try {
          const face = new FontFace(family, `url(${url})`, {
            weight: "normal",
            style: "normal",
          });
          const loaded = await face.load();
          document.fonts.add(loaded);
        } catch {
          /* CSS @font-face ainda pode cobrir */
        }
      })
    );
  }
  await facesPromise;
};

export const preloadTagFonts = async () => {
  injectCssFaces();
  await Promise.all([
    ensureFontsLoaded(MontserratBold, MontserratLight),
    loadDocumentFaces(),
  ]);
  return getFonts();
};

export const tagFontsReady = () => Boolean(getFonts());

preloadTagFonts().catch(() => {
  /* preview/validação ficam sem clamp até retry */
});
